import type { Resource } from '../../';
export const country_countries_BE: Resource = {"default":"Belgium"};
